import clsx from 'clsx';
import React from 'react';
import { IconCollapse, Logo } from '@getstream/ui-library/build';
import * as styles from './button.module.css';

export const ButtonAnimatedLogo = ({ label, to, color = 'default' }) => (
  <a href={to} className={clsx(styles.animatedLogo, 'relative')}>
    <Logo
      customClass={clsx(styles.animatedLogoIcon, 'absolute z-10')}
      color={color}
      width={118}
      height={22}
    />
    <div
      className={clsx(
        styles.animatedLogoLabel,
        'flex items-center bg-white text-black tracking-wider uppercase text-xs rounded-full leading-3 h-7 invisible opacity-0 var-bold',
      )}
    >
      <IconCollapse />
      {label}
    </div>
  </a>
);
